import React from "react"
import FieldFormElementView from "../../../../render/form-elemnent-view"
import {FieldType} from "../../../../field-type"
import FieldsFactory from "../../../../fields-factory"
import FieldProto_FormElement from "../../../../proto/render/form-element"
import {ReportDate} from "../model/model"

const debug = false
// const debug = "FieldAgileReportDate_FormElement"

export default class FieldAgileReportDate_FormElement extends FieldProto_FormElement {

    onPresetChange = (start:number) => {
        const reportDate : ReportDate = this.value
        const newReportDate = reportDate.clone()
        newReportDate.lastDays     = start
        newReportDate.startDate = null
        newReportDate.endDate   = null

        debug && console.log(debug, "onPresetChange",reportDate)

        this.onChange(newReportDate)

        this.forceUpdate()
    }

    onDateRangeChange = (dateRange: any) => {
        const reportDate : ReportDate = this.value
        const newReportDate      = reportDate.clone()
        newReportDate.startDate  = dateRange.start
        newReportDate.endDate    = dateRange.end

        debug && console.log(debug, "onDateRangeChange",dateRange)

        this.onChange(newReportDate)
    }

    render(): JSX.Element | false {
        const reportDate : ReportDate = this.value

        debug && console.log(debug, "render reportDate", reportDate)

        const presetRangeSelector = FieldsFactory.get({
            fieldId             : 'lastDays',
            type                : FieldType.DROPDOWN,
            label               : 'Date range',
            options             : this.props.field.options,
            noValueOption       : false,
            showMenuMore        : false
        })

        const dateRangeSelector = FieldsFactory.get({
            fieldId         : 'dateRange',
            type            : FieldType.DATE_RANGE,
            maxDate         : momentDate(),
            clearButton     : false,
        })

        const presetClasses = Classes("w-300", {
            // "w-300"         : !!reportDate.lastDays,
            // "w-130 m-r-10"  : !reportDate.lastDays,
        })

        const dateRangeModel = !reportDate.lastDays && reportDate.startDate && reportDate.endDate ?
            {dateRange: {start: reportDate.startDate, end: reportDate.endDate}}
            :
            null

        debug && console.log(debug, "render dateRange", dateRangeModel)

        return (
            <div className={Classes("flex-column-left-top", this.props.className)}>
                {presetRangeSelector &&
                    <FieldFormElementView className = {presetClasses}
                                          field     = {presetRangeSelector}
                                          model     = {reportDate}
                                          onChange  = {this.onPresetChange}/>}

                {dateRangeSelector && !reportDate.lastDays &&
                    <FieldFormElementView className = "w-300 m-t-15"
                                          field     = {dateRangeSelector}
                                          model     = {dateRangeModel}
                                          onChange  = {this.onDateRangeChange}/>}
            </div>
        )
    }
}